import { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import { BasicPerson, Person, Skill } from '../../../types';
import { getAttributedOrUnattributedPersonHeading } from '../../../utils/models/Campaign';
import TagsList from '../../Widgets/TagsList';
import { CommentGroup } from './CommentGroup';

interface PersonProps {
  index?: number;
  author?: string | BasicPerson;
  type?: string;
  text?: string;
  skills?: Array<Skill>;
  anonymous?: boolean;
  last?: boolean;
}

const PersonResponseRow: FC<PersonProps> = ({
  index,
  author,
  type,
  text,
  skills,
  anonymous,
  last,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Row key={index}>
      <Col>
        <CommentGroup author={author as Person} noMargin={last}>
          {getAttributedOrUnattributedPersonHeading(
            formatMessage,
            author,
            index,
            type,
            anonymous
          )}
          {text ? (
            <div className="text-dark mb-0 py-1">{text}</div>
          ) : (
            <div className="fst-italic mb-0 py-1">
              <FormattedMessage
                id="app.views.person_response_row.no_comments_provided"
                defaultMessage="No comments provided"
              />
            </div>
          )}
          {!!skills?.length && (
            <TagsList skills={skills} isExternalUrl={true} />
          )}
        </CommentGroup>
      </Col>
    </Row>
  );
};

PersonResponseRow.defaultProps = {
  anonymous: false,
};

export default PersonResponseRow;
